import React from 'react';

export default function ConfirmDialog({ open, title = 'Confirmare', message, confirmText = 'Confirmă', cancelText = 'Anulează', onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-actions">
          <button className="review-btn" onClick={onCancel}>{cancelText}</button>
          <button className="review-btn modal-danger" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

